export type ILoginProps = {
  email: string
  password: string
}

export type TPostBulkQuestions = {
  subject: string
  /** Taxonomy id or legacy name; backend resolves via resolve_upload_topic */
  topic: string
  myFile: File
}

export type QuestionStatus = "draft" | "published" | "archived"

export type SubPart = {
  label: string
  question?: string
  answer?: string
  solution?: string
  marks?: number | null
  marking_scheme?: string
}

export type VerificationStatus = "unverified" | "verified" | "rejected"

export type GeneratedArtifact = {
  artifact_id: string
  object_key: string
  artifact_type?: string | null
  role?: string | null
  visibility?: string | null
  origin?: string | null
  storage_scope?: string | null
  filename?: string | null
  content_type?: string | null
  size_bytes?: number | null
  download_url?: string | null
}

export type QuestionPayload = {
  subject: string
  /** Denormalized display name; prefer topic_id/chapter_id for writes */
  chapter?: string | null
  topic?: string | null
  chapter_id?: string | null
  topic_id?: string | null
  /** Configurable hierarchy levels 2-4 (level 1 == topic/topic_id). */
  level_2_id?: string | null
  level_3_id?: string | null
  level_4_id?: string | null
  grade: string
  complexity: string
  source?: string | null
  year?: number | null
  marks?: number | null
  question_status: QuestionStatus
  /** Whether the question is published/visible to learners. Independent of
   * question_status; only true when question/answer/solution/marking_scheme
   * are all completed. */
  published_to_learner?: boolean
  verification_status?: VerificationStatus | null
  generation_job_id?: string | null
  question: string
  answer?: string | null
  solution?: string | null
  marking_scheme?: string | null
  sub_parts?: SubPart[]
  question_artifacts?: GeneratedArtifact[]
  solution_artifacts?: GeneratedArtifact[]
}

export type TQuestion = QuestionPayload & {
  _id?: string
  id?: string
  bulk_session_id?: string
  subject_title?: string
  topic_id?: string | null
  chapter_id?: string | null
  /** Resolved display names for hierarchy levels 2-4. */
  level_2_name?: string | null
  level_3_name?: string | null
  level_4_name?: string | null
  content_types?: string[]
  created_at?: string
  updated_at?: string
}

export type QuestionListFilter = {
  subject: string
  /** Taxonomy id (ObjectId string) or legacy topic name */
  topic: string
  /** Taxonomy id (ObjectId string) or legacy chapter name */
  chapter: string
  /** Hierarchy level ids (level 1 == topic). Empty string means "any". */
  level_1: string
  level_2: string
  level_3: string
  level_4: string
  grade: string
  year: string
  keyword: string
  content_type: string
  difficultyLevel: string
  question_status: string
  /** "" = any, "true" = live to students, "false" = not live. */
  published_to_learner: string
  verification_status: string
  generation_job_id: string
  bulk_session_id: string
  sort_by: string
  sort_order: string
  page_number: number
  per_page: number
}

export const DEFAULT_QUESTION_LIST_FILTER: QuestionListFilter = {
  subject: "",
  topic: "",
  chapter: "",
  level_1: "",
  level_2: "",
  level_3: "",
  level_4: "",
  grade: "",
  year: "",
  keyword: "",
  content_type: "",
  difficultyLevel: "",
  question_status: "",
  published_to_learner: "",
  verification_status: "",
  generation_job_id: "",
  bulk_session_id: "",
  sort_by: "newest",
  sort_order: "desc",
  page_number: 1,
  per_page: 6,
}
